import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BaseDialogComponent } from '@helpers/base/dialog/dialog.component';

export interface PwaDialogData {
    isUnrecoverable?: boolean;
    reason?: string;
}

@Component({
    selector: 'app-pwa-update-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, MatButtonModule, MatIconModule],
    templateUrl: './pwa-update-dialog.component.html',
})
export class PwaUpdateDialogComponent extends BaseDialogComponent<PwaUpdateDialogComponent, boolean> {
    readonly #dialogRef = inject(MatDialogRef<PwaUpdateDialogComponent, boolean>);
    readonly data = inject<PwaDialogData>(MAT_DIALOG_DATA, { optional: true });

    get isUnrecoverable(): boolean {
        return this.data?.isUnrecoverable ?? false;
    }

    dismiss(): void {
        this.#dialogRef.close(false);
    }

    update(): void {
        this.#dialogRef.close(true);
    }
}
